import { useQuery } from "@tanstack/react-query";
import { getEmployeeWorks } from "../employeeWorks";

export const employeeWorksKeys = {
  all: ["employee-works"] as const,
  byEmployee: (employeeId?: number) =>
    ["employee-works", typeof employeeId === "number" ? employeeId : "all"] as const,
};

export function useEmployeeWorks(employeeId?: number) {
  const isValidEmployeeId =
    typeof employeeId === "number" && Number.isFinite(employeeId) && employeeId > 0;

  return useQuery({
    queryKey: employeeWorksKeys.byEmployee(employeeId),
    queryFn: () => getEmployeeWorks(employeeId),
    enabled: employeeId === undefined ? true : isValidEmployeeId,
  });
}
